export const POST_CP_START_DEMO = 'POST_CP_START_DEMO';

export const POST_CP_START_DEMO_SUCCESS = 'POST_CP_START_DEMO_SUCCESS';

export const POST_CP_START_DEMO_FAILED = 'POST_CP_START_DEMO_FAILED';

export const SHOW_CP_WARNING_POPUP = 'SHOW_CP_WARNING_POPUP';

export const HIDE_CP_WARNING_POPUP = 'HIDE_CP_WARNING_POPUP';
